module.exports = __webpack_public_path__ + "img/empty.ce5940d8.svg";